var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{class:{ mobile: _vm.$mq === 'sm' },attrs:{"href":_vm.link.link_url.url,"title":_vm.link.link_title}},[_vm._v(" "+_vm._s(_vm.link.link_title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }